<div class="container">
  <div class="content" [ngSwitch]="data.type">
    <!-- 商品說明 -->
    <div class="line-height content-padding origin-margin" *ngSwitchCase="infoType.PRODUCT_DETAIL">
      <div class="title origin-title" *ngIf="data.product.origin as origin" i18n>產地：{{origin}}</div>
      <ng-container *ngIf="data.product.material as material">
        <div class="divider"></div>
        <div class="title" i18n>材質成分</div>
        <div class="text-content" [innerHTML]="material | newLineToHtml | safeHTML"></div>
      </ng-container>
      <ng-container *ngIf="data.product.productInfo as info">
        <div class="divider"></div>
        <div class="title">{{info.title}}</div>
        <div  class="text-content info-font-style" [innerHTML]="info.description | productInfoDisplay"></div>
      </ng-container>
    </div>

    <!-- 付款與運送方式 -->
    <div class="column-container content-padding" *ngSwitchCase="infoType.SHIPPING_INFO">
      <div class="shipping-title center-container" i18n>付款與運送方式</div>
      <div class="shipping-container">
        <ng-container *ngFor="let ship of data.product.shippingFee?.feeInfos; let first = first; let last = last">
          <div class="shipping-item"
               [class.shipping-item-padding]="!first">
            <div class="row-container">
              <div class="flex-grow" *ngIf="ship.image; else desc">
                <app-image-loading [src]="ship.image.hash"
                                   [clickable]="false"
                                   [targetWidth]="32"
                                   [targetHeight]="32"
                                   [originalQuality]="true"
                                   [alt]="ship.subTitle"/>
              </div>
              <ng-template #desc>
                <span class="flex-grow">{{ship.desc}}</span>
              </ng-template>
              <div class="base-container">
                <span class="small-dollar">$&nbsp;</span>
                <span>{{ship.fee}}</span>
              </div>
            </div>
            <div class="shipping-sub-title"
                 [class.shipping-padding]="!!ship.desc"
                 [innerHTML]="ship.subTitle | priceColorDisplay">
            </div>
          </div>
          <div *ngIf="!last" class="divider"></div>
        </ng-container>
      </div>
    </div>

    <!-- 海外配送說明 -->
    <div class="column-container content-padding" *ngSwitchCase="infoType.DELIVERY_INFO">
      <div class="shipping-title center-container" i18n>配送說明</div>
      <div class="shipping-container">
        <div *ngIf="data.product.shippingFee as shippingFee">
          <div class="row-container">
            <app-image-loading alt="配送說明" i18n-alt
                               src="assets/icon_notice.svg"
                               [clickable]="false"
                               [targetWidth]="15"
                               [targetHeight]="15"/>
            <div class="oversea-title">{{shippingFee.deliveryTitle}}</div>
          </div>
          <div class="delivery-notice-title">{{shippingFee.deliveryContent}}</div>
        </div>
      </div>
    </div>

    <!-- 尺寸表 -->
    <div class="content-padding" *ngSwitchCase="infoType.SIZE_TABLE">
      <div class="title origin-title" i18n>尺寸表</div>
      <div *ngIf="data.product.sizeChartImage as img">
        <app-image-loading alt="尺寸表" i18n-alt
                           [src]="img.hash"
                           [clickable]="false"
                           [targetWidth]="sizeImgWidth()"
                           [targetHeight]="sizeImgWidth() * img.aspectRatio"/>
      </div>
      <div class="margin-top small-text"
           [innerHTML]="data.product.sizeChartHints | hintsDisplay | newLineToHtml | safeHTML"></div>
      <ng-container
        *ngFor="let img of [data.product.firstSizeMeasurementImage, data.product.secondSizeMeasurementImage]; trackBy: trackByFn">
        <div class="margin-top" *ngIf="img">
          <app-image-loading alt="平放測量圖" i18n-alt
                             [src]="img.hash"
                             [clickable]="false"
                             [targetWidth]="sizeImgWidth()"
                             [targetHeight]="sizeImgWidth() * img.aspectRatio"/>
        </div>
      </ng-container>
    </div>

    <!-- 真人試穿 -->
    <div class="content-padding image-margin-bottom" *ngSwitchCase="infoType.FITTING_TABLE">
      <div class="title origin-title" i18n *ngIf="data.product.isBabyFitting;else fitting">適穿尺寸對照表</div>
      <ng-template #fitting>
        <div class="title origin-title" i18n>真人試穿紀錄</div>
      </ng-template>
      <div *ngIf="data.product.fittingReportImage as imgObj">
        <app-image-loading alt="試穿報告" i18n-alt
                           [targetWidth]="sizeImgWidth()"
                           [targetHeight]="sizeImgWidth() * imgObj.aspectRatio"
                           [clickable]="false"
                           [src]="imgObj.hash"/>
      </div>
    </div>
  </div>

  <button class="common-button bottom-btn" appFocusRemove (click)="onClose()" i18n>完成</button>
</div>
